import { useAuthGate } from '../context/AuthGateContext';
import type { PendingAuthAction } from '../utils/pendingAuthAction';

/** Gate shopping actions behind a logged-in customer account. */
export function useRequireCustomerAuth() {
  const { requireCustomerAuth, isCustomerAuthenticated, openAuthModal } = useAuthGate();

  return {
    isCustomerAuthenticated,
    openAuthModal,
    requireCustomerAuth,
    guardAction: (action: PendingAuthAction, onAuthed: () => void | Promise<void>) =>
      requireCustomerAuth(action, onAuthed),
  };
}
